import Backbone from '@polleverywhere/backbone'
import Tpl from './tpl.hamlc'

export default class Archived extends Backbone.View {
  get className () { return 'archived' }

  initialize (options = {}) {
    if (!options.i18n) {
      console.error('i18n is required.')
    }

    this.i18n = options.i18n
    this.render = this.render.bind(this)
  }

  render () {
    const text = this.i18n("You're currently viewing a past run")

    this.$el.html(Tpl())
    this.$('.text').append(text)

    return this
  }
}
